import _ from 'lodash';
import template from './planRada.html';
import { findVezaByPozicija } from './zubi.svg.js';

class PlanRadaController {
    constructor(DS, AppConfiguration, $q, $uibModal, $state, logger) {
        this.datastore = () => DS;
        this.$q = () => $q;
        this.$uibModal = () => $uibModal;
        this.$state = () => $state;
        this.logger = () => logger;
        this.view = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
        this.pageTitle = 'Plan rada';
    }

    $onInit() {
        const DS = this.datastore();
        DS.find('RadniNalog', this.id, { bypassCache: true }).then(radniNalog => {
            this.item = radniNalog;
            this.pageTitle = `Plan rada: ${radniNalog.pacijent}`;
            this.refreshState();
        });
    }

    refreshState() {
        const DS = this.datastore();
        const $q = this.$q();
        this.nalog = this.item;
        this.stavke = _.cloneDeep(this.nalog.stavke);
        this.veze = _.cloneDeep(this.nalog.veze);
        this.plan = { pozicije: [], veze: [] };

        this.nalog.stavke.map(stavka => {
            this.plan.pozicije.push({ id: stavka.pozicija, protetski_rad: stavka.protetski_rad });
        });

        this.nalog.veze.map(veza => {
            const item = findVezaByPozicija(veza.pozicija);
            if (item !== null && item !== undefined) {
                this.plan.veze.push(Object.assign({}, item));
            }
        });

        $q.all([DS.findAll('ProtetskiRad'), DS.findAll('Cjenik')]).then(response => {
            this.groupStavke(this.stavke);
        });
    }

    groupStavke(stavke) {
        // grupiraj stavke naloga po protetskom radu
        // {
        //     "protetski_rad": 21,
        //     "pozicije": [
        //            12,
        //            22,
        //            18
        //     ],
        //     cjenik: 1
        // },
        const DS = this.datastore();
        const StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
        this.groupedStavke = StavkaNaloga.group(stavke);
    }

    insertStavkuNaloga(pozicije) {
        const $uibModal = this.$uibModal();
        const model = { pozicije: pozicije };

        const modal = $uibModal.open({
            component: 'stavkaNalogaForm',
            size: 'lg-extra',
            // windowClass: 'modal-lg-extra',
            resolve: {
                item: function() {
                    return model;
                }
            }
        });

        return modal.result.then(model => {
            const stavke = [];
            const plan = [];
            if (pozicije.length > 0) {
                pozicije.forEach(pozicija => {
                    stavke.push(Object.assign({}, model, { pozicija: pozicija }));
                });
            } else {
                stavke.push(Object.assign({}, model, { pozicija: null }));
            }
            this.stavke = [...this.stavke, ...stavke];
            this.groupStavke(this.stavke);

            this.stavke.map(s => {
                plan.push({ id: s.pozicija, protetski_rad: s.protetski_rad });
            });

            this.plan = { pozicije: [...plan], veze: [...this.plan.veze] };
        });
    }

    removeStavkuNaloga(item) {
        const plan = [];
        this.stavke = this.stavke.filter(stavka => {
            return !(stavka.protetski_rad === item.protetski_rad && stavka.cjenik === item.cjenik);
        });

        this.stavke.map(s => {
            plan.push({ id: s.pozicija, protetski_rad: s.protetski_rad });
        });

        this.plan = { pozicije: [...plan], veze: [...this.plan.veze] };
        this.groupStavke(this.stavke);
    }

    vezeClicked(veza) {
        const item = _.find(this.plan.veze, { id: veza.id, celjust: veza.celjust });
        if (_.isObject(item)) {
            const veze = this.plan.veze.filter(f => f.id !== item.id || f.celjust !== item.celjust);
            this.plan = Object.assign({}, this.plan, {
                veze: [...veze]
            });
        } else {
            this.plan = Object.assign({}, this.plan, { veze: [...this.plan.veze, veza] });
        }
    }

    submit() {
        const DS = this.datastore();
        const $state = this.$state();
        const logger = this.logger();
        DS.update('PlanRada', this.item.id, { stavke: this.stavke, veze: this.plan.veze })
            .then(response => {
                $state.go('radniNalog.details', { id: this.item.id });
            })
            .catch(error => {
                logger.error('Oupss....', error.data);
            });
    }
}

PlanRadaController.$inject = ['DS', 'AppConfiguration', '$q', '$uibModal', '$state', 'logger'];

const PlanRadaComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: PlanRadaController,
    controllerAs: 'vm',
    bindings: {
        id: '<'
    }
};

export { PlanRadaComponent };
export { PlanRadaController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/planRada.component.js